<script setup lang="ts">
  defineOptions({ name: 'EmCardFooter' })
</script>

<template>
  <div class="emerald-card__footer">
    <slot />
  </div>
</template>
